import React from 'react';
import { Pharmacy } from '../DrMaxPharmacyList/DrMaxPharmacyListItem';
import { joinClasses } from '../../../../Utils/className.util';
import useTranslation from '../../../../Hooks/useTranslation';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import DrMaxPharmacyWorkingHours from '../DrMaxPharmacyWorkingHours/DrMaxPharmacyWorkingHours';
import styles from './DrMaxPharmacy.module.scss';

interface Props {
	item: Pharmacy;
	onChange: () => void;
}

const DrMaxPharmacy: React.FC<Props> = ({ item, onChange }) => {
	const { t } = useTranslation();

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div className={styles.title}>{item.name}</div>
					<div
						className={joinClasses([
							styles.status,
							item.isOpen ? styles.open : styles.closed,
						])}
					>
						{item.isOpen
							? t('component.drmax.pharmacyOpen')
							: t('component.drmax.pharmacyClosed')}
					</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						text={'base.change'}
						onClick={onChange}
						theme={'purple'}
					/>
				</div>
			</div>
		</>
	);
};

export default DrMaxPharmacy;
